export default __webpack_public_path__ + "static/media/emoji-box.6f4f417c.svg";